import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from '../Button/Button';
import type { ButtonProps } from '../Button/Button';

export interface MenuButtonProps extends Omit<ButtonProps, 'icon' | 'iconPosition' | 'iconOnly'> {
  isOpen?: boolean;
}

export const MenuButton = React.forwardRef<HTMLButtonElement, MenuButtonProps>(
  ({ isOpen = false, children, ...props }, ref) => (
    <Button
      ref={ref}
      iconPosition="right"
      icon={
        <ChevronDown
          className={`transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
        />
      }
      {...props}
    >
      {children}
    </Button>
  )
);

MenuButton.displayName = 'MenuButton';


